import React from "react";
import ActionPointHandler from "../../components/ActionPoint/ActionPointHandler";
import BackgroundImageView from "./BackgroundImageView";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";

export default function InteractiveVideoPlayer(props) {
  const {
    backgroundImageLarge,
    backgroundVideoLink,
    backgroundVideoFile,
    actionPoints,
  } = props;

  function renderBackgroundVideo() {
    let source = "";
    if (backgroundVideoFile) {
      source = backgroundVideoFile;
    } else if (backgroundVideoLink) {
      source = backgroundVideoLink;
    }
    if (source) {
      return (
        <video
          id="backgroundVideo"
          // onPlay={console.log("video has started")}
          onEnded={handleOnEnd}
          className={isMobileOrTablet() ? "view__video-mobile" : "view__video"}
          playsInline
          loop={navigateToPageOnVideoEnd ? false : true}
          muted
          autoPlay
        >
          <source src={source} type="video/mp4" />
        </video>
      );
    } else {
      return null;
    }
  }
  return (
    <>
      <ActionPointHandler actionPoints={actionPoints} />

      {renderBackgroundVideo()}
      <BackgroundImageView
        backgroundImage={backgroundImageLarge}
        backgroundVideoFile={backgroundVideoFile}
        backgroundVideoLink={backgroundVideoLink}
        videoVimeo={""}
        videoDacast={""}
      />
    </>
  );
}
